var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "title", rawName: "v-title" }],
      staticClass: "container",
      attrs: { "data-title": "我的邀请记录" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-list" },
        [
          _vm._l(_vm.invitationRecords, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "record-container-cell flex cross-center"
              },
              [
                _c("span", { staticClass: "record-name" }, [
                  _vm._v(_vm._s(item.name))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "record-cer-status",
                    style: {
                      color: _vm.authenticationTextColor(item.authentication)
                    }
                  },
                  [_vm._v(_vm._s(item.authentication))]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "record-time" }, [
                  _vm._v(_vm._s(_vm._f("dateAndMinTime")(item.registerTime)))
                ])
              ]
            )
          }),
          _vm._v(" "),
          !_vm.invitationRecords || _vm.invitationRecords.length === 0
            ? _c(
                "div",
                {
                  staticClass:
                    "record-container-cell flex main-center cross-center"
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: { "font-size": "14px", color: "#999999FF" }
                    },
                    [_vm._v("暂无记录")]
                  )
                ]
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "record-container" }, [
      _c("div", { staticClass: "record-container-tip flex cross-center" }, [
        _c("span", { staticClass: "record-name" }, [_vm._v("昵称")]),
        _vm._v(" "),
        _c("span", { staticClass: "record-cer-status" }, [_vm._v("认证状态")]),
        _vm._v(" "),
        _c("span", { staticClass: "record-time" }, [_vm._v("注册时间")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-044187de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-044187de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/invitation/teacher/InvitationTeacherRecord.vue
// module id = null
// module chunks = 